export const TOGGLE_SEARCH_INPUT = 'TOGGLE_SEARCH_INPUT';
export const SET_ADD_PRODUCT_ANIMATION = 'SET_ADD_PRODUCT_ANIMATION';

export const toggleSearchInput = () => ({
  type: TOGGLE_SEARCH_INPUT,
});

export const setAddProductAnimation = (state: boolean) => ({
  type: SET_ADD_PRODUCT_ANIMATION,
  state,
});
